import {
  QDivider,
  QFlex,
  QIconButton,
  QualioQThemeProvider,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

export const FileDocumentControls = ({
  currentPage,
  totalPages,
  handleNavigate,
  handleZoom,
  showDownloadButton,
  handleDownload,
  zoom,
  isPaginated,
  isImage,
  handlePagination,
  handlePrint,
  showCommentButton,
  isXlsx,
}: {
  currentPage?: number;
  totalPages?: number;
  handleNavigate?: (page: number) => void;
  handleZoom: (zoom: number) => void;
  showDownloadButton: boolean;
  handleDownload: () => void;
  zoom: number;
  isPaginated?: boolean;
  isImage?: boolean;
  handlePagination?: () => void;
  handlePrint?: () => void;
  showCommentButton: boolean;
  isXlsx?: boolean;
}) => {
  const { t } = useTranslation();

  const handleNavigateNext = () => {
    handleNavigate && handleNavigate(1);
  };

  const handleNavigatePrev = () => {
    handleNavigate && handleNavigate(-1);
  };

  const handleZoomIn = () => {
    handleZoom(0.1);
  };

  const handleZoomOut = () => {
    handleZoom(-0.1);
  };

  const paginateStyle = {
    transform: `${isPaginated ? '' : 'rotate(-90deg)'}`,
    display: `${isImage ? 'none' : 'block'}`,
  };

  return (
    <div
      id={'controls'}
      data-cy="previewControlWrapper"
      style={{ width: '100%' }}
    >
      <QualioQThemeProvider>
        <QFlex w="100%" justify="right">
          <QFlex hidden={!isPaginated}>
            <QIconButton
              data-cy="file-document-previous-page-button"
              onClick={handleNavigatePrev}
              isDisabled={currentPage === 1}
              size="lg"
              iconName="ChevronLeft"
              aria-label={t('messages.previousPage')}
            />
            <div style={{ lineHeight: '48px' }}>
              {t('messages.pageCount', { currentPage, totalPages })}
            </div>
            <QIconButton
              data-cy="file-document-next-page-button"
              onClick={handleNavigateNext}
              isDisabled={currentPage === totalPages}
              size="lg"
              iconName="ChevronRight"
              aria-label={t('messages.nextPage')}
            />
          </QFlex>
          <QIconButton
            data-cy="file-document-zoom-out-button"
            onClick={handleZoomOut}
            isDisabled={zoom < 0.2}
            size="lg"
            iconName="ZoomOut"
            aria-label={t('messages.zoomOut')}
          />
          <QIconButton
            data-cy="file-document-zoom-in-button"
            onClick={handleZoomIn}
            isDisabled={zoom === 3.5}
            size="lg"
            iconName="ZoomIn"
            aria-label={t('messages.zoomIn')}
          />
          {!isXlsx && (
            <div style={paginateStyle}>
              <QIconButton
                data-cy="file-document-toggle-pagination-button"
                onClick={handlePagination}
                size="lg"
                iconName="Code"
                aria-label={t('messages.togglePagination')}
              />
            </div>
          )}
          {showDownloadButton && (
            <QIconButton
              data-cy="file-document-download-button"
              onClick={handleDownload}
              size="lg"
              iconName="Download"
              aria-label={t('buttons.download')}
            />
          )}
          {handlePrint && (
            <QIconButton
              data-cy="file-document-print-button"
              onClick={handlePrint}
              size="lg"
              iconName="Printer"
              aria-label={t('buttons.print')}
            />
          )}
          {showCommentButton && (
            <QIconButton
              data-cy="file-document-comment-button"
              iconName={'MessageSquare'}
              aria-label={t('buttons.comment')}
              size="lg"
              isDisabled={true}
            />
          )}
        </QFlex>
        <QDivider mt="6" mb="6" />
      </QualioQThemeProvider>
    </div>
  );
};
